import React from 'react';
import { useTranslation } from 'react-i18next';
import { Url } from '@wix/da-url';
import { BiEventType } from '@wix/da-bi/pkg/constants';
import useTierPopup from '../../../Tier/TierPopup/useTierPopup';
import BaseTierUpsell from './BaseTierUpsell';
export var WantToSellTierUpsell = function (_a) {
    var className = _a.className;
    var t = useTranslation().t;
    var openCreateTierPopup = useTierPopup();
    return (React.createElement(BaseTierUpsell, { className: className, imageSrc: Url.staticCDNLink('eclipse/global/svg/tier-upsell-want-to-sell.svg'), imageWidth: "128px", title: t('deviation.tier.upsell.title.wantToSell'), subtitle: t('deviation.tier.upsell.subtitle.wantToSell'), buttonText: t('deviation.tier.upsell.button.wantToSell'), onClick: openCreateTierPopup, biData: {
            evid: BiEventType.DEFAULT,
            click_info: 'tier.upsell.want_to_sell',
        } }));
};
WantToSellTierUpsell.displayName = 'WantToSellTierUpsell';
export default WantToSellTierUpsell;
//# sourceMappingURL=WantToSellTierUpsell.js.map